import * as React from 'react'
import { EmptyStatePage } from '../EmptyStatePage/EmptyStatePage'

export const NotFound = () => {
  return (
    <EmptyStatePage
      is404={true}
      emptyStateTitle={'404 Not Found'}
      emptyStateSubtitle={'The page your are looking for does not exist. Please check URL.'}
    />
  )
}
